import { render, staticRenderFns } from "./ToolBadge.vue?vue&type=template&id=d4e47742"
import script from "./ToolBadge.vue?vue&type=script&lang=js"
export * from "./ToolBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports